// Bangla Translations
export const bn = {
  // Common
  common: {
    dashboard: 'ড্যাশবোর্ড',
    home: 'হোম',
    profile: 'প্রোফাইল',
    settings: 'সেটিংস',
    logout: 'লগআউট',
    login: 'লগইন',
    signup: 'সাইন আপ',
    cancel: 'বাতিল',
    save: 'সংরক্ষণ',
    delete: 'মুছুন',
    edit: 'সম্পাদনা',
    close: 'বন্ধ',
    back: 'পিছনে',
    next: 'পরবর্তী',
    previous: 'পূর্ববর্তী',
    submit: 'জমা দিন',
    search: 'খুঁজুন',
    filter: 'ফিল্টার',
    loading: 'লোড হচ্ছে...',
    error: 'ত্রুটি',
    success: 'সফল',
    confirm: 'নিশ্চিত করুন',
    yes: 'হ্যাঁ',
    no: 'না',
    ok: 'ঠিক আছে'
  },
  
  // Dashboard
  dashboard: {
    welcome: 'স্বাগতম',
    overview: 'সারসংক্ষেপ',
    appointments: 'অ্যাপয়েন্টমেন্ট',
    prescriptions: 'প্রেসক্রিপশন',
    reports: 'রিপোর্ট',
    subscriptions: 'সাবস্ক্রিপশন',
    orders: 'অর্ডার',
    cart: 'কার্ট',
    notifications: 'বিজ্ঞপ্তি',
    noNotifications: 'কোন বিজ্ঞপ্তি নেই',
    viewAll: 'সব দেখুন',
    markAllAsRead: 'সব পড়া হয়েছে হিসাবে চিহ্নিত করুন',
    hello: 'হ্যালো',
    there: 'সেখানে',
    howAreYouFeeling: 'আজ আপনি কেমন অনুভব করছেন?',
    yourDoctor: 'আপনার ডাক্তার',
    yourData: 'আপনার তথ্য',
    change: 'পরিবর্তন',
    videoConsultation: 'ভিডিও পরামর্শ',
    joinCall: 'কলে যোগ দিন',
    message: 'বার্তা',
    call: 'কল',
    noAssignedDoctor: 'কোন ডাক্তার নির্ধারিত নেই',
    findDoctor: 'ডাক্তার খুঁজুন',
    weight: 'ওজন',
    height: 'উচ্চতা',
    blood: 'রক্ত',
    age: 'বয়স',
    phone: 'ফোন',
    address: 'ঠিকানা',
    generalPractitioner: 'সাধারণ চিকিৎসক',
    kg: 'কেজি',
    m: 'মি',
    years: 'বছর',
    yearsOld: 'বছর বয়স',
    noData: 'এন/এ',
    healthRecords: 'স্বাস্থ্য রেকর্ড',
    marketplace: 'মার্কেটপ্লেস',
    services: 'সেবা',
    billing: 'বিলিং',
    lightMode: 'লাইট মোড',
    darkMode: 'ডার্ক মোড',
    diagnostic: 'ডায়াগনস্টিক',
    listOfDiseases: 'রোগের তালিকা',
    myDrugs: 'আমার ওষুধ',
    prescribedMedicine: 'প্রেসক্রিপশন করা ওষুধ',
    tests: 'পরীক্ষা',
    labTestResults: 'ল্যাব পরীক্ষার ফলাফল',
    switchToLightMode: 'লাইট মোডে পরিবর্তন করুন',
    switchToDarkMode: 'ডার্ক মোডে পরিবর্তন করুন',
    bookNewAppointment: 'নতুন অ্যাপয়েন্টমেন্ট বুক করুন',
    bookAppointment: 'অ্যাপয়েন্টমেন্ট বুক করুন',
    joinVideoCall: 'ভিডিও কলে যোগ দিন',
    cancelAppointment: 'অ্যাপয়েন্টমেন্ট বাতিল করুন',
    cancelling: 'বাতিল করা হচ্ছে...',
    noAppointmentsScheduled: 'কোন অ্যাপয়েন্টমেন্ট নির্ধারিত নেই',
    noAppointmentsMessage: 'আপনার কোন আসন্ন অ্যাপয়েন্টমেন্ট নেই। আপনার স্বাস্থ্যসেবা যাত্রা শুরু করতে আপনার প্রথম অ্যাপয়েন্টমেন্ট বুক করুন।',
    type: 'ধরন',
    fee: 'ফি',
    videoConsultation: 'ভিডিও পরামর্শ',
    inPersonVisit: 'ব্যক্তিগত পরিদর্শন',
    areYouSureCancel: 'আপনি কি নিশ্চিত যে আপনি এই অ্যাপয়েন্টমেন্ট বাতিল করতে চান?',
    appointmentCancelled: 'অ্যাপয়েন্টমেন্ট সফলভাবে বাতিল হয়েছে',
    errorCancelling: 'অ্যাপয়েন্টমেন্ট বাতিল করতে ত্রুটি',
    connectedTo: 'সংযুক্ত',
    agent: 'এজেন্ট',
    waitingForAgent: 'এজেন্টের জন্য অপেক্ষা করা হচ্ছে...',
    liveChat: 'লাইভ চ্যাট',
    endChat: 'চ্যাট শেষ করুন',
    noMessagesYet: 'এখনও কোন বার্তা নেই।',
    typeYourMessage: 'আপনার বার্তা টাইপ করুন...',
    send: 'পাঠান',
    addImage: 'ছবি যোগ করুন',
    sendImage: 'ছবি পাঠান',
    remove: 'সরান'
  },
  
  // Appointments
  appointments: {
    title: 'অ্যাপয়েন্টমেন্ট',
    upcoming: 'আসন্ন অ্যাপয়েন্টমেন্ট',
    past: 'পূর্ববর্তী অ্যাপয়েন্টমেন্ট',
    bookAppointment: 'অ্যাপয়েন্টমেন্ট বুক করুন',
    cancelAppointment: 'অ্যাপয়েন্টমেন্ট বাতিল করুন',
    appointmentDetails: 'অ্যাপয়েন্টমেন্ট বিবরণ',
    doctor: 'ডাক্তার',
    date: 'তারিখ',
    time: 'সময়',
    status: 'স্ট্যাটাস',
    pending: 'অপেক্ষমান',
    confirmed: 'নিশ্চিত',
    completed: 'সম্পন্ন',
    cancelled: 'বাতিল'
  },
  
  // Orders
  orders: {
    title: 'আমার অর্ডার',
    orderId: 'অর্ডার আইডি',
    orderDate: 'অর্ডার তারিখ',
    total: 'মোট',
    status: 'স্ট্যাটাস',
    viewDetails: 'বিবরণ দেখুন',
    noOrders: 'কোন অর্ডার পাওয়া যায়নি',
    pending: 'অপেক্ষমান',
    processing: 'প্রক্রিয়াকরণ',
    shipped: 'প্রেরিত',
    delivered: 'ডেলিভারি হয়েছে',
    cancelled: 'বাতিল'
  },
  
  // Payment
  payment: {
    title: 'পেমেন্ট',
    amount: 'পরিমাণ',
    paymentMethod: 'পেমেন্ট পদ্ধতি',
    payNow: 'এখনই পে করুন',
    paymentSuccessful: 'পেমেন্ট সফল',
    paymentFailed: 'পেমেন্ট ব্যর্থ',
    selectMethod: 'পেমেন্ট পদ্ধতি নির্বাচন করুন',
    cardPayment: 'কার্ড পেমেন্ট',
    mobileBanking: 'মোবাইল ব্যাংকিং',
    onlineBanking: 'অনলাইন ব্যাংকিং'
  },
  
  // Emergency Services
  emergency: {
    title: 'জরুরি সেবা',
    oxygenCylinder: 'অক্সিজেন সিলিন্ডার',
    wheelchair: 'হুইলচেয়ার',
    nurse: 'জরুরি নার্স',
    bookNow: 'এখনই বুক করুন',
    subscribe: 'সাবস্ক্রাইব করুন',
    currentSubscriptions: 'বর্তমান সাবস্ক্রিপশন',
    subscriptionPlans: 'সাবস্ক্রিপশন প্ল্যান'
  },
  
  // Checkout
  checkout: {
    title: 'চেকআউট',
    shippingAddress: 'শিপিং ঠিকানা',
    orderSummary: 'অর্ডার সারসংক্ষেপ',
    total: 'মোট',
    subtotal: 'উপমোট',
    discount: 'ছাড়',
    loyaltyPoints: 'লয়্যালটি পয়েন্ট',
    useLoyaltyPoints: 'লয়্যালটি পয়েন্ট ব্যবহার করুন',
    placeOrder: 'অর্ডার করুন',
    couponCode: 'কুপন কোড',
    applyCoupon: 'কুপন প্রয়োগ করুন'
  }
};

